const selectors = {
  el: '[data-toggle-class]',
  classTarget: '[data-toggle-class-target]',
}

document.addEventListener('click', e => {
  const target = e.target
  if (!target.matches(selectors.el)) return

  const targetClassList = target.matches(selectors.classTarget) ? document.querySelector(target.dataset.toggleClassTarget).classList : document.body.classList

  targetClassList.toggle(target.dataset.toggleClass)
})
